import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { AuthService } from '@shared/services/auth.service'
import { AppUser } from '@shared/models/app-user.model'
import { formatHours } from '@shared/const/hours/hours-formatter.const'
import { LeaderboardOwnRow } from '@shared/models/leaderboard.model'
import { LeaderboardService } from '@shared/services/leaderboard.service'
import { ToastService } from '../../services/toast.service'

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss'],
  standalone: false,
})
export class ProfilePageComponent implements OnInit, OnDestroy {
  currentUser: AppUser | null = null
  showDeletePopup = false
  volunteering: LeaderboardOwnRow | null = null
  formatHours = formatHours
  private profileSubscription?: Subscription

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService,
    private leaderboardService: LeaderboardService
  ) {}

  ngOnInit(): void {
    this.profileSubscription = this.authService.appUser$.subscribe({
      next: user => (this.currentUser = user),
      error: () => (this.currentUser = null),
    })
    this.leaderboardService.getLeaderboard().subscribe({
      next: leaderboard => (this.volunteering = leaderboard.me),
      error: () => (this.volunteering = null),
    })
  }

  ngOnDestroy(): void {
    this.profileSubscription?.unsubscribe()
  }

  openDeletePopup(): void {
    this.showDeletePopup = true
  }

  closeDeletePopup(): void {
    this.showDeletePopup = false
  }

  onAccountDeleted(): void {
    this.profileSubscription?.unsubscribe()
    this.currentUser = null
    this.closeDeletePopup()
    this.toastService.showSuccess('A fiókod törlése megtörtént.')
    this.router.navigate(['/login']).catch(() => {
      this.toastService.showError('A bejelentkezési oldal megnyitása nem sikerült. Frissítsd az oldalt.')
    })
  }
}
